/**
 * 第三方推广链接的路由参数
 */

const state = {
  _routeParam: null
};

const getters = {
  routeParam: (state) => state._routeParam
};

const mutations = {
  saveRouteParam(state, data) {
    state._routeParam = data ? data : {};
  }
};

const actions = {};

export default {
  state,
  getters,
  mutations,
  actions
};
